export default __webpack_public_path__ + "static/CILogoColoured-217efa62e057692cc186c907c6c0bdb1.svg";